// Jennie's Jewelry & Accessories - Shopify Theme JS
(function() {
  window.openCartDrawer = function() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) {
      drawer.classList.add('active');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  };

  window.closeCartDrawer = function() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) {
      drawer.classList.remove('active');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  };

  window.toggleMobileNav = function() {
    var nav = document.getElementById('mobile-nav-drawer');
    if (nav) {
      nav.classList.toggle('active');
    }
  };

  window.openSearchModal = function() {
    var modal = document.getElementById('search-modal');
    if (modal) {
      modal.classList.add('active');
      modal.setAttribute('aria-hidden', 'false');
      var input = modal.querySelector('input');
      if (input) setTimeout(function() { input.focus(); }, 100);
    }
  };

  window.closeSearchModal = function() {
    var modal = document.getElementById('search-modal');
    if (modal) {
      modal.classList.remove('active');
      modal.setAttribute('aria-hidden', 'true');
    }
  };

  window.toggleProductWishlist = function(btn, id) {
    if (!btn) return;
    btn.classList.toggle('active');
  };

  window.switchMainProductImage = function(src, thumbBtn) {
    var mainImg = document.getElementById('ProductMainImage');
    if (mainImg) {
      mainImg.src = src;
    }
    var allThumbs = document.querySelectorAll('.thumb-item');
    allThumbs.forEach(function(t) { t.classList.remove('active'); });
    if (thumbBtn) {
      thumbBtn.classList.add('active');
    }
  };

  window.stepQuantity = function(change) {
    var qtyInput = document.getElementById('Quantity');
    if (qtyInput) {
      var current = parseInt(qtyInput.value, 10) || 1;
      var updated = Math.max(1, current + change);
      qtyInput.value = updated;
    }
  };

  window.selectVariantOption = function(btn, position, value) {
    var container = btn.closest('.option-values-wrap');
    if (container) {
      var buttons = container.querySelectorAll('.option-pill-btn');
      buttons.forEach(function(b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
    }
  };

  window.buyItNowDirect = function(formId) {
    var form = document.getElementById(formId);
    if (form) {
      var returnInput = document.createElement('input');
      returnInput.type = 'hidden';
      returnInput.name = 'return_to';
      returnInput.value = '/checkout';
      form.appendChild(returnInput);
      form.submit();
    }
  };

  window.updateCartQuantity = function(lineItemKey, newQty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItemKey, quantity: newQty })
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      location.reload();
    })
    .catch(function(err) {
      console.error(err);
      location.reload();
    });
  };

  window.handleCollectionSort = function(sortValue) {
    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('sort_by', sortValue);
    window.location.href = currentUrl.toString();
  };

  window.toggleCollectionFilters = function() {
    var sidebar = document.getElementById('CollectionSidebar');
    if (sidebar) {
      sidebar.classList.toggle('active');
    }
  };

})();
